<template>
  <div>
    <router-view v-bind:user.sync="user"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        token: '',
        isClient: false
      },
    }
  },
  created () {
    this.initializeLiff()
  },
  methods: {
    initializeLiff() {
      var me = this
      this.user.isClient = liff.isInClient()

      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID
        },
        data => {
          if (liff.isLoggedIn()) {
            // IDトークン取得
            me.user.token = liff.getAccessToken()
          } else {
            this.loginAction()
          }
        },
        err => {
          console.log('LIFF initialization failed', err)
        }
      )

    },
    loginAction() {
      // ログインまだ
      if (!liff.isLoggedIn()) {
        liff.login()
      }
    }
  }
}
</script>